import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  ImageList,
  ImageListItem
} from "@material-ui/core";

// Contexts
import CloudinaryContext from "../../../../context/cloudinary/CloudinaryContext";

// Components
import Spinner from "../../../layout/SpinnerSmall";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 500,
  },
  list: {
    textAlign: "center",
    margin: 5,
  },
  listSelected: {
    margin: 2,
    border: `3px solid ${theme.palette.error.main}`,
  },
  image: {
    "&:focus": {
      outline: "none",
    },
    objectFit: "contain",
  },
  load: {
    marginTop: "1rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const AvatarSelection = ({ browserOpenState, browserSelect, image_url }) => {
  const classes = useStyles();

  const { browse_loading, images, image_next_cursor, browseImage } =
    useContext(CloudinaryContext);

  const folder_path = "checkout_images/misc/avatar";
  const [browserOpen, setBrowserOpen] = browserOpenState;
  const [selectedImage, setSelectedImage] = useState("");

  const onClose = () => setBrowserOpen(false);

  const onSave = () => {
    browserSelect(selectedImage);
    onClose();
  };

  useEffect(() => {
    if (browserOpen) browseImage(false);
    if (image_url) setSelectedImage(image_url);
  }, [browserOpen]);

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="md"
      open={browserOpen}
      onClose={onClose}
    >
      <DialogTitle> Select Avatar </DialogTitle>
      <DialogContent dividers className={classes.root}>
        <ImageList cols={6} rowHeight="auto">
          {images && images.length === 0 && (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{
                width: "100%",
                height: 435,
              }}
            >
              <Typography variant="body1"> No image found. </Typography>
            </Grid>
          )}
          {images &&
            images.map((image) => {
              return (
                <ImageListItem key={image.public_id}>
                  <div
                    className={clsx({
                      [classes.list]: true,
                      [classes.listSelected]:
                        selectedImage === image.secure_url,
                    })}
                    onClick={() => setSelectedImage(image.secure_url)}
                  >
                    <img
                      height="130"
                      width="130"
                      src={image.secure_url}
                      className={classes.image}
                      alt=""
                    />
                  </div>
                </ImageListItem>
              );
            })}
        </ImageList>
        {image_next_cursor && (
          <Grid container justifyContent="center" className={classes.load}>           
            {browse_loading ? (
              <Spinner />
            ) : (
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={() => browseImage(folder_path, true)}
              >
                Load more
              </Button>
            )}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onSave}
          disabled={selectedImage ? false : true}
        >
          Select
        </Button>
        <Button
          variant="contained"
          className={classes.button}
          onClick={onClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AvatarSelection;
